/**
 * package: com.inq.flash.client.chatskins
 * class: FontMgr
 * root Object
 * @constructor
 */
com.inq.flash.client.chatskins.FontMgr = function() {
};
$hxClasses.registerClass(com.inq.flash.client.chatskins.FontMgr, "com.inq.flash.client.chatskins.FontMgr");

/**
 * init
 *
 * $type TFun([],TEnum(Bool,[]))
 * public static function init():Bool
 * @public
 * @static
 * @return {boolean}
 */
com.inq.flash.client.chatskins.FontMgr.init = function () {
	if (com.inq.flash.client.chatskins.FontMgr.defaultSkin == null) {
		/** @type {string} */
		var fullyQualifiedSkinPath = com.inq.flash.client.control.FlashPeer.getSkin();
		if (com.inq.flash.client.control.FlashPeer.isEmbeddedThemeValid()) {
			fullyQualifiedSkinPath = com.inq.flash.client.control.PersistenceManager.GetValue(EMBEDDED_SKIN_PATH, fullyQualifiedSkinPath);
		} else {
			fullyQualifiedSkinPath = com.inq.flash.client.control.PersistenceManager.GetValue(SKIN_PATH, fullyQualifiedSkinPath);
		}
		com.inq.flash.client.chatskins.FontMgr.defaultSkin = fullyQualifiedSkinPath;
	}

	/** @type {?string} */
	var skin = com.inq.utils.Util.getConfig("nextSkin", null);
	var fmt = com.inq.flash.client.control.FlashPeer.getChatSkinFmt()
	if (skin != null) {
		skin = skin.replace(/\.(skin|zip)$/, "." + fmt);
	}
	com.inq.flash.client.chatskins.FontMgr.nameNextSkin = skin;

	var liveAgentSkin = com.inq.utils.Util.getConfig("liveAgentSkin", null);

	if(liveAgentSkin && !com.inq.flash.client.control.FlashPeer.getIsSkinLocal()) {
		liveAgentSkin = liveAgentSkin.replace(/\.(skin|zip)$/, "." + fmt);
		com.inq.flash.client.chatskins.FontMgr.liveAgentSkin = liveAgentSkin;
		com.inq.ui.SkinLoader.PreloadNewSkin(liveAgentSkin);
	}

	if (com.inq.flash.client.chatskins.SkinControl.isInApplication("btnFontSize")) {
		var fontBtn = Application.application.getButton("btnFontSize");
		fontBtn.addEventListener(com.inq.events.MouseEvent.CLICK, com.inq.flash.client.chatskins.FontMgr.actionBtnNewFont);
		fontBtn.setVisible(true);
		if (com.inq.flash.client.chatskins.FontMgr.isCssModeUsed()) {
			fontBtn.setupDefaultStateLabels([
				com.inq.flash.client.chatskins.FontMgr.FONT_SIZE_SMALL_LABEL,
				com.inq.flash.client.chatskins.FontMgr.FONT_SIZE_LARGE_LABEL
			]);
			if (com.inq.flash.client.control.PersistenceManager.GetValue(FONT_SIZE_INCREASED, false)) {
				com.inq.flash.client.chatskins.FontMgr.isLarger = true;
				fontBtn.setState(com.inq.flash.client.chatskins.FontMgr.FONT_SIZE_LARGE_LABEL_INDEX);
				com.inq.flash.client.chatskins.FontMgr.applyFontSizeNewWay();
			} else {
				com.inq.flash.client.chatskins.FontMgr.isLarger = false;
				fontBtn.setState(com.inq.flash.client.chatskins.FontMgr.FONT_SIZE_SMALL_LABEL_INDEX);
			}
		}

		if (com.inq.flash.client.chatskins.FontMgr.nameNextSkin && !com.inq.flash.client.control.FlashPeer.getIsSkinLocal()) {
		    com.inq.ui.SkinLoader.PreloadNewSkin(com.inq.flash.client.chatskins.FontMgr.nameNextSkin);
		    haxe.Log.trace("skin is " + com.inq.flash.client.chatskins.FontMgr.nameNextSkin, { fileName: "FontMgr.hx", lineNumber: 50, className: "com.inq.flash.client.chatskins.FontMgr", methodName: "init" });
		}
	}

	return true;
};



/**
 * toggleFontSize
 *
 * $type TFun([],TEnum(Bool,[]))
 * private static functiontobbleFontSize():String
 * @private
 * @static
 * @return {String}
 */
com.inq.flash.client.chatskins.FontMgr.toggleFontSize = function (size) {
    size = parseInt(size);
    var newSize = 0;
    if (com.inq.flash.client.chatskins.FontMgr.isLarger) {
        newSize = size + 3;
	} else {
		newSize = size - 3;
    }
    return newSize.toString();
};

/**
 * toggleElements
 *
 * $type TFun([],TEnum(Bool,[]))
 * private static function toggleElements():Void
 * @private
 * @static
 * @return {Void}
 */
com.inq.flash.client.chatskins.FontMgr.toggleElements = function (elements) {

    var isDivChat = com.inq.utils.Util.getConfig("divSkin", false) && !com.inq.flash.client.chatskins.SkinControl.getIsPersistentChat();
    var chatsWindow = (isDivChat === true) ? window.parent.window : window;
	var fontSize = null;
	var fontUnits = null;
	var el = null;
	if (elements && elements.length > 0) {
		for (var i = 0; i < elements.length; i++) {
			el = elements[i];
			if (chatsWindow.getComputedStyle !== null) {
				fontSize = chatsWindow.getComputedStyle(el, null).fontSize;
			} else if (el.currentStyle.fontSize !== null) {
			    fontSize = el.currentStyle.fontSize;
		    }
		    fontUnits = fontSize.slice(-2);
		    fontSize = fontSize.slice(0, -2);
			el.style.setProperty("font-size", com.inq.flash.client.chatskins.FontMgr.toggleFontSize(fontSize) + fontUnits, "important");
	    }
    }
};

com.inq.flash.client.chatskins.FontMgr.getChatTranscriptElements = function (parentEl) {
	return [parentEl.getElementsByClassName("customerId"),
			parentEl.getElementsByClassName("customerMsg"),
			parentEl.getElementsByClassName("agentId"),
			parentEl.getElementsByClassName("agentMsg"),
			parentEl.getElementsByClassName("systemMsg"),
			parentEl.getElementsByClassName("systemStatMsg"),
			parentEl.getElementsByClassName("agentMsgTime"),
			parentEl.getElementsByClassName("customerMsgTime"),
			parentEl.getElementsByClassName("todayMsgTime"),
			parentEl.getElementsByClassName("msgDate")];
};

com.inq.flash.client.chatskins.FontMgr.applyFontSizeAfterMsg = function (parentEl) {
    if (com.inq.utils.Util.getConfig("nextSkin", null) == null) {
        if (com.inq.flash.client.chatskins.FontMgr.isLarger) {
			// apply font size for regenerated transcript in chat window
			var items = com.inq.flash.client.chatskins.FontMgr.getChatTranscriptElements(parentEl);
			for (var i = 0; i < items.length; i++) {
				com.inq.flash.client.chatskins.FontMgr.toggleElements(items[i]);
			}
        }
    }
};

/**
 * Toggles the chat skin font size.
 * This is a wrapper for _applyFontSizeNewWay method.
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.FontMgr.applyFontSizeNewWay = function() {
	/** @type {Document} */
	var chatDocument = com.inq.utils.Util.isDivChat() ? window.parent.document : window.document;
	com.inq.flash.client.chatskins.FontMgr._applyFontSizeNewWay(chatDocument);
	com.inq.flash.client.chatskins.FontMgr.setFontState(com.inq.flash.client.chatskins.FontMgr.isLarger);
};

/**
 *	Sets font state to larger or default value.
 *	We should implement condition for checking if font size has already been changed in and "old way"
 *	by loading "nextSkin". In this case we don't save additional cookies to save space.
 *
 *  @public
 * 	@static
 * 	@param {boolean} isLarger
 */
com.inq.flash.client.chatskins.FontMgr.setFontState = function(isLarger) {
	if (com.inq.flash.client.chatskins.FontMgr.isCssModeUsed()) {
		com.inq.flash.client.control.PersistenceManager.SetValue(FONT_SIZE_INCREASED, isLarger);
	}
};

/**
 * Determines the collection of elements and toggles font size for these elements.
 *
 * @private
 * @static
 * @param {Document} owner - Document
 */
com.inq.flash.client.chatskins.FontMgr._applyFontSizeNewWay = function (owner) {
	/**
	 * Stores the scroll value of the transcript, this value must be obtained
	 * before changing the 'font-size' property so that it has the actual value.
	 *
	 * @type {boolean}
	 */
	var transcriptScrolledToBottom = com.inq.flash.client.chatskins.SkinControl.isTranscriptScrolledToBottom();
	var items = com.inq.flash.client.chatskins.FontMgr.getChatTranscriptElements(com.inq.flash.client.chatskins.SkinControl.getChatWindow()._ta._div);
	// additional controls of the chat window interface
	/** @type {HTMLElement} */
	var stageElement = com.inq.ui.Stage.getStageElement();
	if (stageElement.nodeName === "IFRAME") {
		stageElement = com.inq.ui.Container.getElementById(com.inq.ui.SkinLoader.OVERALL_CONTAINER_ID);
	}

	if (stageElement) {
		items.push(stageElement.getElementsByTagName("textarea"));
	} else {
		com.inq.flash.client.control.FlashPeer.logError("stageElement is " + stageElement + " in applyFontSizeNewWay, skin URL: " + com.inq.ui.SkinLoader.getSkinURL());
	}

	if (com.inq.ui.Container._getElementById(com.inq.flash.client.chatskins.FontMgr.EMAIL_PANEL_ID, owner)) {
		items.push(com.inq.ui.Container._getElementById(com.inq.flash.client.chatskins.FontMgr.EMAIL_PANEL_ID, owner)
			.getElementsByTagName("div"));
	}

	for (var i = 0; i < items.length; i++) {
		com.inq.flash.client.chatskins.FontMgr.toggleElements(items[i]);
    }

	/*
	 It is needed for adjusting transcript position after changing 'font-size' property of the messages
	 because the value of the HTMLElements is changed one by one directly and it affects scroll position.
	 */
	if (transcriptScrolledToBottom) {
		com.inq.flash.client.chatskins.SkinControl.scrollTranscriptToEnd();
	}
};

/**
 * actionBtnNewFont
 *
 * $type TFun([{ name => me, t => TInst(com.inq.events.MouseEvent,[]), opt => false }],TEnum(Void,[]))
 * public static function actionBtnNewFont(me:MouseEvent):Void
 * @public
 * @static
 * @param {com.inq.events.MouseEvent}  me
 * @return {void}
 */

com.inq.flash.client.chatskins.FontMgr.actionBtnNewFont = function (me) {
	com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.isTouched = true;
	if (com.inq.flash.client.chatskins.FontMgr.isCssModeUsed()) {
		/** @type {com.inq.ui.Button} */
		var fontSizeButton = Application.application.getButton("btnFontSize");
		if (com.inq.flash.client.chatskins.FontMgr.isLarger) {
			com.inq.flash.client.chatskins.FontMgr.isLarger = false;
			fontSizeButton.setState(com.inq.flash.client.chatskins.FontMgr.FONT_SIZE_SMALL_LABEL_INDEX);
		} else {
			com.inq.flash.client.chatskins.FontMgr.isLarger = true;
			fontSizeButton.setState(com.inq.flash.client.chatskins.FontMgr.FONT_SIZE_LARGE_LABEL_INDEX);
		}
		com.inq.flash.client.chatskins.FontMgr.applyFontSizeNewWay();
	} else {
		try {
			if (com.inq.flash.client.control.FlashPeer.isV3Continue()) {
				com.inq.flash.client.control.ApplicationController.isSkipRestoreMsgOnce = true;

				var skinName = com.inq.flash.client.control.FlashPeer.getSkin();
				if (com.inq.flash.client.control.FlashPeer.isEmbeddedThemeValid()) {
					skinName = com.inq.flash.client.control.PersistenceManager.GetValue(EMBEDDED_SKIN_PATH, skinName);
				} else {
					skinName = com.inq.flash.client.control.PersistenceManager.GetValue(SKIN_PATH, skinName);
				}
				//when we load a skin, its name is stored by persistence mgr, if the stored name == nameNextSkin ( which is the alternate font size skin, usually ....-XL.skin)
				//then we handle the font button click by toggleing to the original skin/font size
				// todo: this should not toggle, more than one alt font size/skin could be specified by skin config , should cycle
				if (com.inq.flash.client.chatskins.FontMgr.nameNextSkin == skinName) {
					var defaultSkinFileName = com.inq.flash.client.chatskins.FontMgr.defaultSkin;
					defaultSkinFileName = defaultSkinFileName.replace(com.inq.ui.SkinLoader.getSkinBase(), '');
					defaultSkinFileName = defaultSkinFileName.replace("/", '');
					com.inq.ui.SkinLoader.LoadNewSkin(defaultSkinFileName);
				} else {
					com.inq.ui.SkinLoader.LoadNewSkin(com.inq.flash.client.chatskins.FontMgr.nameNextSkin);
				}
			}
		}
		catch (error) {
			haxe.Log.trace("Error setting new font:" + error.msg + " " + error.type + "\n", { fileName: "FontMgr.js", lineNumber: 101, className: "com.inq.flash.client.control.FontMgr", methodName: "actionBtnNewFont" })
		}
	}
};

/**
 * Restores the correct 'font-size' value for elements in the Email Panel.
 * @param {HTMLElement} elem
 */
com.inq.flash.client.chatskins.FontMgr.restoreFontSizeForEmailPanel = function (elem) {
	/** @type {string} */
	var elemId = elem && elem.id;
	/** @type {HTMLDocument} */
	var owner = com.inq.utils.Util.isDivChat() ? window.parent.document : window.document;
	/** @type {HTMLElement|null} */
	var container = com.inq.ui.Container._getElementById(com.inq.flash.client.chatskins.FontMgr.EMAIL_PANEL_ID, owner);

	if (com.inq.flash.client.chatskins.FontMgr.isLarger && container && elemId) {
		if (com.inq.flash.client.chatskins.FontMgr.EMAIL_PANEL_ID === elemId) {
			com.inq.flash.client.chatskins.FontMgr.toggleElements(container.getElementsByTagName("div"));
		} else if (container.querySelector('#' + elemId)) {
			com.inq.flash.client.chatskins.FontMgr.toggleElements([elem]);
		}
	}
};

/**
 * Returns a flag indicating that a new way to change the font size is used.
 * It used when "nextSkin" property is not defined in the skin MXML,
 * hence "nameNextSkin" will be not specified as well.
 * But actually this way updates the style on every element in chat UI.
 * @see {com.inq.flash.client.chatskins.FontMgr.applyFontSizeNewWay}
 * @see {com.inq.flash.client.chatskins.FontMgr.toggleElements}
 * @return {boolean}
 */
com.inq.flash.client.chatskins.FontMgr.isCssModeUsed = function() {
	return !com.inq.flash.client.chatskins.FontMgr.nameNextSkin;
};

/** @private @type {string} */
com.inq.flash.client.chatskins.FontMgr.nameNextSkin = null;

/** @private @type {boolean} */
com.inq.flash.client.chatskins.FontMgr.isLarger = false;

/** @private @type {string} */
com.inq.flash.client.chatskins.FontMgr.FONT_SIZE_LARGE_LABEL = "Font size large. Select to reduce font size";

/** @private @type {string} */
com.inq.flash.client.chatskins.FontMgr.FONT_SIZE_SMALL_LABEL = "Font size small. Select to enlarge font size";

/** @type {number} */
com.inq.flash.client.chatskins.FontMgr.FONT_SIZE_SMALL_LABEL_INDEX = 0;
/** @type {number} */
com.inq.flash.client.chatskins.FontMgr.FONT_SIZE_LARGE_LABEL_INDEX = 1;

/** @type {string} */
com.inq.flash.client.chatskins.FontMgr.EMAIL_PANEL_ID = "tcChat_emailFormInput";
